import { Link } from "react-router-dom";
import ContactLayout from "./layouts/Contact";

function Contact() {
    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Contact</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            
                            <li className="breadcrumb-item active" aria-current="page">
                                <Link to="/contact" className="text-white">Contact</Link>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <ContactLayout />
        </>
    );
}

export default Contact;